// extracted by mini-css-extract-plugin
export default {"label":"eeE5b5L5fhDWl1wvWzva","size-lg":"Bi0VCmFbjDeHq6asQxLW"};